function setCheckoutDisabled(disabled) {
  document.querySelectorAll('.cart__checkout-button').forEach(function (button) {
    button.disabled = disabled;
    button.classList.toggle('checkout-disabled', disabled);
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  });
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const variantId = this.dataset.variantId;
    const pairs = window.freebieOfferPairs || {};
      if (pairs[variantId]) {
        cartItems.removeWithCompanion(this.dataset.index, variantId, pairs[variantId]);
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'short-nav-cart-new',
        section: 'sticky-footer',
        selector: '#short-nav-cart-new'
      },
      {
        id: 'desktopRecommend',
        section: 'cart-drawer',
        selector: '.cart-recommend-desktop'
      }
    ];
  }
removeWithCompanion(line, clickedVariantId, companionVariantId) {
    setCheckoutDisabled(true);
  this.enableLoading(line);

  const body = JSON.stringify({
    updates: {
      [clickedVariantId]: 0,
      [companionVariantId]: 0,
    },
    sections: this.getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
  });

  fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then((parsedState) => {
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector,
        );
      });

      this.disableLoading();
    })
    .catch((e) => {
      console.error('Error removing items:', e);
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      this.disableLoading();
    })
    .finally(() => {
      if (
        document.body.classList.contains('overflow-cart-hidden') ||
        document.body.classList.contains('overflow-hidden')
      ) {
        document.body.classList.remove('overflow-cart-hidden', 'overflow-hidden');
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.classList.add('cart-space-desktop');
      }
      startTimer();
    });
}
  updateQuantity(line, quantity, name) {
      setCheckoutDisabled(true);
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
                this.checkAndSyncCompanion(parsedState);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      })
      .finally(() => {
                document.querySelector('#CartDrawer-Overlay').addEventListener('click', function() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
        cartDrawer.classList.remove('active');
        }
        });
        if (document.body.classList.contains('overflow-cart-hidden') || document.body.classList.contains('overflow-hidden')) {
            document.body.classList.remove('overflow-cart-hidden', 'overflow-hidden');
           var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.add('cart-space-desktop');
            }
        }
        startTimer();
      });
  }
  checkAndSyncCompanion(parsedState) {
    const pairs = window.freebieOfferPairs || {};
    if (!parsedState || !Array.isArray(parsedState.items)) return;
 
    Object.keys(pairs).forEach((triggerId) => {
      const companionId = pairs[triggerId];
      if (!companionId) return;
 
      const triggerItem = parsedState.items.find(
        (item) => String(item.variant_id) === String(triggerId)
      );
      const companionItem = parsedState.items.find(
        (item) => String(item.variant_id) === String(companionId)
      );
 
      const triggerQty = Math.min(triggerItem ? triggerItem.quantity : 0, 1);
      const companionQty = companionItem ? companionItem.quantity : 0;
 
      if (triggerQty === companionQty) return; 
 
      if (companionItem) {
        fetch(`${routes.cart_change_url}`, {
          ...fetchConfig(),
          ...{
            body: JSON.stringify({
              id: companionItem.key,
              quantity: triggerQty,
              sections: this.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname,
            }),
          },
        })
          .then((response) => response.json())
          .then((newState) => this.applySyncedSections(newState))
          .catch((e) => console.error('Error syncing companion quantity:', e));
      } else if (triggerQty > 0) {
        // companion cart me nahi hai -> trigger ki quantity jitni fresh add kar do
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: companionId, quantity: triggerQty }],
            sections: this.getSectionsToRender().map((section) => section.section),
          }),
        })
          .then((response) => response.json())
          .then((newState) => this.applySyncedSections(newState))
          .catch((e) => console.error('Error adding companion:', e));
      }
    });
  }
 
  applySyncedSections(newState) {
    this.classList.toggle('is-empty', newState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');
 
    if (cartFooter) cartFooter.classList.toggle('is-empty', newState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', newState.item_count === 0);
 
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        newState.sections[section.section],
        section.selector
      );
    });
      setCheckoutDisabled(false);
  }
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

function startTimer() {
    const now = new Date();
    const currentTime = now.getTime();
    const targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 14, 0, 0).getTime();

    if (currentTime > targetTime) {
      document.querySelector('.Cart_Time').style.display = "none";
      document.querySelector('.variant-pop-box .countdown-on').style.display = "none";
      return;
    }

    let secondsLeft = Math.floor((targetTime - currentTime) / 1000);

    function timer() {
      const hours = Math.floor(secondsLeft / 3600);
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;

      if (secondsLeft <= 0) {
        document.querySelector('.Cart_Time').style.display = "none";
        document.querySelector('.variant-pop-box .countdown-on').style.display = "none";
        clearInterval(timerInterval);
        return;
      }

      document.querySelectorAll(".countdown-text").forEach((element) => {
        element.innerHTML = (hours < 10 ? "0" : "") + hours + ": " + 
                            (minutes < 10 ? "0" : "") + minutes + ": " + 
                            (seconds < 10 ? "0" : "") + seconds + " hours!";
      });

      secondsLeft--;
    }

    timer();
    const timerInterval = setInterval(timer, 1000);
  }